import { useReadAccess } from 'src/app/AppAuth/useReadAccess'
import React from 'react'
import { useParams } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import {
  CONTROL_STATUS,
  Control,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { BasicDropdownMenu } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import {
  BASIC_DROPDOWN_ALIGN,
  BASIC_DROPDOWN_DROP,
} from 'src/components/Reusable/BasicDropdown/BasicDropdown.constants'
import { useBasicDropdown } from 'src/components/Reusable/BasicDropdown/context/BasicDropdownContext'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { DropdownToggleButton } from '../../../../components/Reusable/Buttons'
import { ReactComponent as VerticalEllipsesIcon } from '../../../../components/Icons/assets/vertical-ellipses-icon.svg'
import { useCurrentControl } from '../../../../context/FormContext'
import { TestIds } from '../../../../Utils/testIds'
import {
  ViewDetails,
  RemoveControl,
  CopyLink,
  InScopeItems,
  DeleteControl,
  ViewActivities,
  LinkToExternal,
} from './ControlsListItemMenuComponents'

export const ControlsListItemMenu = ({
  control,
}: {
  control: Control.AsObject
}): JSX.Element => {
  const canDeleteControls = useCanPerformAction<Control.AsObject>(
    CAPABILITY.CAN_DELETE_CONTROLS,
    control,
  )
  const canViewActivities = useReadAccess(CAPABILITY.CAN_VIEW_ACTIVITY_LOG)
  const canViewRequests = useReadAccess(CAPABILITY.CAN_VIEW_REQUESTS)
  const { setCurrentControl } = useCurrentControl()
  const { requestId } = useParams()

  const setCurrentControlHandler = () => {
    setCurrentControl(control)
  }

  const isNotApplicable = control.status === CONTROL_STATUS.NOTAPPLICABLE

  const { openDropdownId, setOpenDropdownId } = useBasicDropdown()
  const dropdownId = `controls-index-menu-${control.id}`
  const isOpen = openDropdownId === dropdownId

  const handleToggle = (nextOpen: boolean) => {
    if (nextOpen) {
      setOpenDropdownId(dropdownId)
    } else if (isOpen) {
      setOpenDropdownId(null)
    }
  }

  if (!canViewRequests && requestId) {
    return <></>
  }

  return (
    <Dropdown
      id={dropdownId}
      show={isOpen}
      onToggle={handleToggle}
      align={BASIC_DROPDOWN_ALIGN.END}
      drop={BASIC_DROPDOWN_DROP.DOWN}
    >
      <Dropdown.Toggle
        as={DropdownToggleButton}
        onClickFunc={setCurrentControlHandler}
        data-testid={TestIds.CONTROL_LIST_ITEM_MENU_TOGGLE}
      >
        <VerticalEllipsesIcon />
      </Dropdown.Toggle>
      <BasicDropdownMenu>
        {requestId ? (
          <>
            <ViewDetails />
            <RemoveControl {...{ requestId, control }} />
            <CopyLink />
          </>
        ) : (
          <>
            <ViewDetails />
            <Dropdown.Divider />
            {!isNotApplicable && <InScopeItems control={control} />}
            <LinkToExternal control={control} />
            {canDeleteControls && (
              <>
                <DeleteControl />
                <Dropdown.Divider />
              </>
            )}
            <CopyLink />
            {canViewActivities && <ViewActivities />}
          </>
        )}
      </BasicDropdownMenu>
    </Dropdown>
  )
}
